import { wwtMemo } from '@wwt/custom/wwt'

interface GuestInformationGridElementProps {
	title: string
	content: string
	key?: number
}

/**
 * Element for render in grid with defined styles
 *
 * @author Ivan Shchedrovskyi
 */
export const GuestInformationGridElement = wwtMemo(
	({ title, content }: GuestInformationGridElementProps) => {
		return (
			<div>
				<div className="ts-7 text-gray-500">{title}</div>
				<div className="ts-6 mt-1 text-gray-300">{content}</div>
			</div>
		)
	}
)
